import {
  FormTab,
  ReferenceInput,
  required,
  SelectInput,
  TabbedForm,
  TextInput,
} from "react-admin";
import "./RedirectedApiClientForm.css";
import resourceNames from "../../../common/data/resourceNames";

interface Props {}

export const RedirectedApiClientForm = (props: Props) => {
  return (
    <TabbedForm className="form-create-edit" variant="outlined" {...props}>
      <FormTab label="resources.admin-api-clients.labels.basicDetails">
        <TextInput
          source="apiClientName"
          label="resources.admin-api-clients.labels.name"
          validate={required()}
        />

        <ReferenceInput
          source="companyId"
          reference={resourceNames.ADMIN_COMPANIES}
          validate={required()}
        >
          <SelectInput />
        </ReferenceInput>
      </FormTab>
    </TabbedForm>
  );
};
